// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericPageLayout_container__sJOR_","contentContainer":"GenericPageLayout_contentContainer__OYCIr"};